import React, { useEffect, useState } from "react";
import { Input, dateFormat } from "../../components/Form";
import ModalBox from "../../components/modal/ModalBox";
import { PaginationShow } from "../../comman/action/Pagination";
import NotFound from "../../components/not-found/NotFound";
import { IconButton } from "@mui/material";
import { Button } from "../../components/Button/Button";
import {
  addCategoryApi,
  blockCategoryApi,
  fathCategoryApi,
  updateCategoryApi,
} from "../../services/category";
import useButtonLoader from "../../hooks/UseButtonLoader";
import { useSearchParams } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import {
  catchMessage,
  elseMessage,
  successMessage,
} from "../../comman/Message";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import Switch from "../../components/Switch/Switch";

const CategoryManagement = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  const [search, setSearch] = useState(searchParam.get("query") || "");
  const debounceValue = useDebounce(search || "", 300);
  const activePage = +searchParam.get("page") || 1;

  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const [categoryList, setCategoryList] = useState([]);
  const [total, setTotal] = useState(0);
  const [orderByName, setOrderByName] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [direction, setDirection] = useState("ASC");
  const [statusModal, setStatusModal] = useState(false);
  const [statusId, setStatusId] = useState("");
  const [titleName, setTitleName] = useState("");
  const [status, setStatus] = useState("");
  const [updateModal, setUpdateModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [buttonref, buttonLoader] = useButtonLoader(
    addModal ? "Add" : "Update"
  );
  const [input, setInput] = useState({ title: "" });
  const [error, setError] = useState({});
  // console.log("stats type", typeof(status))
  // console.log("input", input)
  const validation = () => {
    let status = true;
    let errorMessage = {};

    if (!input?.title) {
      errorMessage["title"] = "Please enter category name";
      status = false;
    }

    setError(errorMessage);
    return status;
  };
  //--------------handle-page------------------------
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  //--------------sorting-name------------------------
  const orderByNameFun = () => {
    const newDirection = orderByName === "ASC" ? "DESC" : "ASC";
    setOrderByName(newDirection);
    setFieldName("title");
    setDirection(newDirection);
  };
  //--------------status-handle------------------------
  const handleStatus = (id, name, status) => {
    setStatusModal(true);
    setStatusId(id);
    setTitleName(name);
    setStatus(status);
  };
  //--------------update-handler------------------------
  const updateHandle = (id, name) => {
    setUpdateModal(true);
    setStatusId(id);
    setInput({ title: name });
  };
  //--------------sorting-name------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "title") {
      let cleanedName = value.replace(/^[ ]+/g, "").replace(/\s+/g, " "); // Remove leading and trailing spaces
      setInput({
        ...input,
        [name]: cleanedName,
      });
    }
  };
  //------------------modal-close--------------------------
  const modalClose = () => {
    setAddModal(false);
    setUpdateModal(false);
    setInput({ title: "" });
    setError({});
  };
  //------------------listing-Api----------------------------------
  const fathCategory = async (
    page = activePage,
    search = debounceValue,
    sortField = fieldName,
    sortDirection = direction
  ) => {
    showLoader();
    setCategoryList([]);
    try {
      const res = await fathCategoryApi({
        page,
        search,
        sortField,
        sortDirection,
      });
      if (res?.data?.status === 200) {
        hideLoader();
        setCategoryList(res?.data?.data?.list || []);
        setTotal(res?.data?.data?.total);
      } else {
        hideLoader();
        elseMessage(res);
        setCategoryList([]);
      }
    } catch (err) {
      hideLoader();
      catchMessage(err);
      setCategoryList([]);
    }
  };
  //--------------Add-category------------------------
  const addCategory = async () => {
    const status = validation();
    if (status) {
      try {
        buttonLoader(true);
        const res = await addCategoryApi(input);
        if (res.data.status === 200) {
          successMessage(res);
          setAddModal(false);
          fathCategory();
          buttonLoader(false);
          setInput({ title: "" });
        } else {
          elseMessage(res);
          buttonLoader(false);
        }
      } catch (e) {
        catchMessage(e);
        buttonLoader(false);
      }
    }
  };
  //--------------update-category------------------------
  const updateCategory = async () => {
    const status = validation();
    if (status) {
      const data = { categoryId: statusId, title: input?.title };
      buttonLoader(true);
      try {
        const res = await updateCategoryApi(data);
        if (res?.data?.status === 200) {
          successMessage(res);
          setUpdateModal(false);
          fathCategory();
          buttonLoader(false);
          setInput({ title: "" });
        } else {
          buttonLoader(false);
          elseMessage(res);
        }
      } catch (err) {
        catchMessage(err);
        buttonLoader(false);
      }
    }
  };
  //----------------delete-hashtag--------------------------
  const changeStatus = async () => {
    try {
      const updatedStatus = (!status).toString();
      const res = await blockCategoryApi({
        categoryId: statusId,
        status: !status,
      });
      if (res?.data?.status === 200) {
        setStatusModal(false);
        fathCategory();
        successMessage(res);
      } else {
        elseMessage(res);
      }
    } catch (err) {
      catchMessage(err);
    }
  };
  useEffect(() => {
    if (debounceValue) {
      searchParam.set("query", debounceValue);
    } else {
      searchParam.delete("query");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    setSearchParam(searchParam);
    fathCategory(activePage, debounceValue, fieldName, direction);
  }, [activePage, debounceValue, fieldName, direction]);
  useEffect(() => {
    if (search) {
      searchParam.set("page", "");
    }
  }, [search]);
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Category Management</h4>
            <Button onClick={() => setAddModal(true)}>Create Category</Button>
          </div>
          <div className="FilterBox FilterArea">
            <div className="form-group search">
              <input
                type="search"
                className="form-control"
                placeholder="Search"
                value={search || ""}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>
                    <div className="sorting-th" onClick={orderByNameFun}>
                      <span>Category title</span>
                      {orderByName === "ASC" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                      )}
                    </div>
                  </th>
                  <th>Created At</th>
                  <th className="text-center"> Action </th>
                </tr>
              </thead>
              <tbody>
                {categoryList.length > 0 ? (
                  categoryList.map(
                    (
                      { _id, title, hashtagNumber, createdAt, status },
                      index
                    ) => {
                      return (
                        <React.Fragment key={_id || index}>
                          <tr>
                            <td>{++index + (activePage - 1) * 10}</td>
                            <td>{title || "N/A"}</td>
                            <td>{dateFormat(createdAt) || "N/A"}</td>
                            <td>
                              <div className="d-flex justify-content-center">
                                <IconButton
                                  aria-label="update"
                                  onClick={() => updateHandle(_id, title)}
                                >
                                  <DriveFileRenameOutlineIcon
                                    sx={{ color: "#C86337", fontSize: 26 }}
                                  />
                                </IconButton>
                                <Switch
                                  checked={status}
                                  onChange={() =>
                                    handleStatus(_id, title, status)
                                  }
                                />
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )
                ) : (
                  <NotFound
                    cols={10}
                    msg="No Category Found!"
                    icon={<CategoryRoundedIcon style={{ fontSize: 48 }} />}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          <PaginationShow
            total={total}
            activePage={activePage}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
      {/* --------delete-hastage-modal---------- */}
      <ModalBox
        status={statusModal}
        onClose={() => setStatusModal(false)}
        title={`Are you sure you want to ${
          status ? "block" : "unblock"
        } this category and connected resources`}
        description={
          <span>
            The resources linked with this category will also get{" "}
            {!status ? "unblocked" : "blocked"}
          </span>
        }
        action={changeStatus}
      />
      {/* --------add-category-modal---------- */}
      <ModalBox
        status={addModal || updateModal}
        onClose={modalClose}
        title={addModal ? "Add category" : "Update Category"}
        closeIcon
        custom
        customizedFooter={
          addModal ? (
            <button className="btn_size" ref={buttonref} onClick={addCategory}>
              Add
            </button>
          ) : (
            <button
              className="btn_size"
              ref={buttonref}
              onClick={updateCategory}
            >
              Update
            </button>
          )
        }
      >
        <Input
          type="text"
          name="title"
          className="form-control"
          label="Category"
          placeholder="Enter category"
          value={input?.title || ""}
          onChange={handleChange}
          maxLength={50}
          error={error.title}
        />
      </ModalBox>
      {/* --------update-category-modal---------- */}
      {/* < ModalBox
                status={updateModal}
                onClose={modalClose}
                title="update category"
                closeIcon
                custom
                customizedFooter={< button className='btn_size' ref={buttonref} onClick={addCategory} > update</button >}
            >
                <Input
                    type="text"
                    name="title"
                    className='form-control'
                    label="Category"
                    placeholder="Enter hashtag"
                    value={input?.title || ""}
                    onChange={handleChange}
                    maxLength={50}
                    error={error.title}
                />
            </ModalBox > */}
    </>
  );
};

export default CategoryManagement;
